import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = {
	state: false,
	objState : false,
	processState : false,
	vtstate : false,
	vmstate : false,
	imstate : false,
	vpcstate : false,
	bmstate : false,
	ovtstate : false,
	iptstate : false,
	iistate : false, //Indexed Imagery
	oustate : false, //output unity
	objName : '',
	objType : '',
	objSources : [],
	totalFileSize : 0,
	cumulFileSize : 0,
	currentFileSize : 0,
    project : 0,
	options: {
		children: null
	}
};
const viewObjects = createSlice({
	name: 'viewObject',
	initialState: initialState,
	reducers: {
		openObjectDialog :  (state: any, action: PayloadAction<any>) => {
			state.objState = true;
			state.project = action.payload.project;
		},
		closeObjectDialog :  (state: any, action: PayloadAction<any>) => {
			state.objState = false;
			state.options = action.payload;
		},
		openDialog: (state: any, action: PayloadAction<any>) => {
			state.state = true;
			state.objName = action.payload.objName;
		},
		closeDialog: (state: any, action: PayloadAction<any>) => {
			state.state = false;
			state.options = action.payload;
		},
		openVoxelTerrainDialog: (state: any, action: PayloadAction<any>) => {
			state.vtstate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeVoxelTerrainDialog: (state: any, action: PayloadAction<any>) => {
			state.vtstate = false;
			state.options = action.payload;
		},
		openVoxelizedMeshDialog: (state: any, action: PayloadAction<any>) => {
			state.vmstate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeVoxelizedMeshDialog: (state: any, action: PayloadAction<any>) => {
			state.vmstate = false;
			state.options = action.payload;
		},
		openIndexedMeshDialog: (state: any, action: PayloadAction<any>) => {
			state.imstate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeIndexedMeshDialog: (state: any, action: PayloadAction<any>) => {
			state.imstate = false;
			state.options = action.payload;
		},
		openVoxelBlockModelDialog: (state: any, action: PayloadAction<any>) => {
			state.bmstate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeVoxelBlockModelDialog: (state: any, action: PayloadAction<any>) => {
			state.bmstate = false;
			state.options = action.payload;
		},
		openVoxelPointCloudDialog: (state: any, action: PayloadAction<any>) => {
			state.vpcstate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeVoxelPointCloudDialog: (state: any, action: PayloadAction<any>) => {
			state.vpcstate = false;
			state.options = action.payload;
		},
		openOrthoVoxelTerrainDialog: (state: any, action: PayloadAction<any>) => {
			state.ovtstate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeOrthoVoxelTerrainDialog: (state: any, action: PayloadAction<any>) => {
			state.ovtstate = false;
			state.options = action.payload;
		},
		openIndexedPointDialog: (state: any, action: PayloadAction<any>) => {
			state.iptstate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeIndexedPointDialog: (state: any, action: PayloadAction<any>) => {
			state.iptstate = false;
			state.options = action.payload;
		},
		openProcessDialog: (state: any, action: PayloadAction<any>) => {
			state.processState = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeProcessDialog: (state: any, action: PayloadAction<any>) => {
			state.processState = false;
			state.objName = action.payload.objName;
		},
		openOutputUnityDialog: (state: any, action: PayloadAction<any>) => {
			state.oustate = true;
			state.objName = action.payload.objName;
		},
		closeOutputUnityDialog: (state: any, action: PayloadAction<any>) => {
			state.oustate = false;
			state.objName = action.payload.objName;
		},
		openIndexedImageryDialog: (state: any, action: PayloadAction<any>) => {
			state.iistate = true;
			state.objName = action.payload.objName;
			state.objType = action.payload.objType;
			state.objSources = action.payload.objSources;
		},
		closeIndexedImageryDialog: (state: any, action: PayloadAction<any>) => {
			state.iistate = false;
			state.objName = action.payload.objName;
		},
		setProject: (state: any, action: PayloadAction<any>) => {
			state.project = action.payload;
		},
		setTotalFileSize: (state: any, action: PayloadAction<any>) => {
			state.totalFileSize = action.payload
		},
		setCumulFileSize: (state: any, action: PayloadAction<any>) => {
			state.cumulFileSize += action.payload
		},
		setCurrentFileSize: (state: any, action: PayloadAction<any>) => {
			state.currentFileSize = action.payload
		}
	}
});

export const { 
	openDialog, 
	closeDialog, 
	openProcessDialog, 
	closeProcessDialog, 
	openVoxelTerrainDialog, 
	closeVoxelTerrainDialog, 
	openOrthoVoxelTerrainDialog, 
	closeOrthoVoxelTerrainDialog, 
	openIndexedPointDialog, 
	closeIndexedPointDialog, 
	openVoxelizedMeshDialog,
	closeVoxelizedMeshDialog,
	openIndexedMeshDialog,
	closeIndexedMeshDialog,
	openVoxelBlockModelDialog,
	closeVoxelBlockModelDialog,
	openVoxelPointCloudDialog,
	closeVoxelPointCloudDialog,
	openOutputUnityDialog,
	closeOutputUnityDialog,
	setProject, 
	openObjectDialog, 
	closeObjectDialog, 
	setTotalFileSize, 
	setCumulFileSize, 
	setCurrentFileSize,
	openIndexedImageryDialog,
	closeIndexedImageryDialog
 } = viewObjects.actions;

export default viewObjects.reducer;
